var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "0 0 161 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 80.5,
    r: 80.5,
    fill: "#E9FAEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1445_33273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.502 62.2092C126.17 58.9338 120.767 58.9338 117.435 62.2092L86.029 93.0775L80.88 88.0166L68.8125 99.8776L77.7526 108.665C82.3234 113.157 89.7342 113.157 94.3052 108.665L129.502 74.0701C132.834 70.7949 132.834 65.4844 129.502 62.2092Z",
    fill: "#2F4858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0352 82.2899L85.4409 51.4216C88.7733 48.1462 94.176 48.1462 97.5084 51.4216C100.841 54.697 100.841 60.0073 97.5084 63.2827L62.3116 97.8774C57.7408 102.37 50.33 102.37 45.759 97.8774L31.4993 83.8617C28.1669 80.5863 28.1669 75.276 31.4993 72.0006C34.8317 68.7254 40.2344 68.7254 43.5668 72.0006L54.0352 82.2899Z",
    fill: "#2F4858"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1445_33273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 67,
    fill: "white",
    transform: "translate(29 47)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCheck);
export default __webpack_public_path__ + "static/media/double_check.b67607fcd04a7f872fb44e8543d68faa.svg";
export { ForwardRef as ReactComponent };